import { render, staticRenderFns } from "./siteactionrequired.vue?vue&type=template&id=2cd03490&scoped=true"
import script from "./siteactionrequired.vue?vue&type=script&lang=js"
export * from "./siteactionrequired.vue?vue&type=script&lang=js"
import style0 from "./siteactionrequired.vue?vue&type=style&index=0&id=2cd03490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd03490",
  null
  
)

export default component.exports